export default [
  {
    path: '/badges',
    component: () => import('./views/Index'),
    name: 'badges',
    redirect: { name: 'badges-list' },
    children: [
      {
        path: '',
        name: 'badges-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
      {
        path: 'detail/:id',
        name: 'badges-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
